import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthenticationManageService } from '@ddt-web/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class MeAuthGuard implements CanActivate {
	constructor(private authManagerService: AuthenticationManageService) { }

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.authManagerService.getUserAuthenticated()
			.pipe(
				take(1),
				map((authenticated) => {
					const redirectUrlPath = state.url.split('?')?.[0];
					if (!authenticated) {
						this.authManagerService.initializeOktaSignIn({ redirectUrlPath });
					}
					return true;
				})
			);
	}
}

